import { AbstractBluetoothLowEnergyAdapter } from './AbstractBluetoothLowEnergyAdapter';
import { VelocityBluetoothLowEnergyAdapter } from './VelocityBluetoothLowEnergyAdapter';
import { CrossFrameBluetoothLowEnergyAdapter } from './CrossFrameBluetoothLowEnergyAdapter';
import { EnvironmentDetail } from '@src/utils';

/**
 * Resolves the adapter for the current environment, caching it after the first call.
 *
 * Resolution is deferred to first use rather than done at module load, so the environment is fully
 * initialised before it is inspected.
 */
export class BluetoothLowEnergyAdapterProvider {
    private static instance: AbstractBluetoothLowEnergyAdapter;

    /**
     * Returns the adapter for the current environment, constructing it on the first call.
     *
     * @return the cached adapter — a VelocityBluetoothLowEnergyAdapter on the Velocity browser, where
     *   there is no CandyCane bridge and every operation rejects, otherwise a
     *   CrossFrameBluetoothLowEnergyAdapter that routes through ATBase.
     */
    public static get(): AbstractBluetoothLowEnergyAdapter {
        if (!BluetoothLowEnergyAdapterProvider.instance) {
            if (EnvironmentDetail.isVelocityBrowser(window)) {
                BluetoothLowEnergyAdapterProvider.instance = new VelocityBluetoothLowEnergyAdapter();
            } else {
                BluetoothLowEnergyAdapterProvider.instance = new CrossFrameBluetoothLowEnergyAdapter();
            }
        }
        return BluetoothLowEnergyAdapterProvider.instance;
    }
}
